import { z, uuidSchema } from '@kc3/validation';
import { baseEventFields } from './_base.js';
export const GdprErasureEventSchema = z.object({
    type: z.literal('gdpr.erasure'),
    ...baseEventFields,
    subjectId: uuidSchema,
    requestId: uuidSchema,
    requestedBy: uuidSchema,
    scope: z.array(z.string().min(1)).min(1),
});
//# sourceMappingURL=gdpr.js.map